import { Component, OnInit } from '@angular/core';
import { AltriDocumentiService } from './altro.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'altro',
  templateUrl: './altro.component.html',
  styleUrls: ['./altro.component.scss'],
  providers: [AltriDocumentiService]
})
export class AltroComponent implements OnInit {

  modelList: any[] = [];
  promiseBusy: Promise<any[]>;
  // Base per i PDF (dominio pubblico, non l'API con porta)
  websiteUrl = `${environment.publicSiteBase}/docs/documenti_pdf/`;
  //websiteUrl = 'https://centrofunzionale-coll.regione.campania.it/docs/documenti_pdf/';
  constructor(private restService: AltriDocumentiService) { }

  ngOnInit() {
    this.createDocumentiList();
  }

  createDocumentiList() {
    this.restService.selectAll().then(
      res => {
        if (!res || res.length === 0) {
          this.modelList = [];
          return;
        }

        let modelAggregate = {};

        res.documentiBindList.forEach(item => {
          let tipo = item.idCategoria;

          if (!modelAggregate[tipo]) {
            modelAggregate[tipo] = {
              idCategoria: tipo,
              elements: []
            };
          }

          modelAggregate[tipo].elements.push({
            url: item.url,
            descrizione: item.descrizione
          });
        });


        this.modelList = Object.values(modelAggregate);
        console.log(this.modelList);
        console.log(this.modelList.length > 0);




      }
    ).catch(error => {
      this.modelList = [];
    });
  }


}
